import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ReactApexChart from 'react-apexcharts';
import { useMetricsCore } from '../../../core/modules/metrics';
import { useMemo } from 'react';
import { Paper } from '@mui/material';
import { formatCurrency } from '../../../core/utils/formating';

function TotalWidget() {
  const theme = useTheme();
  const { distributions } = useMetricsCore();

  const labels = useMemo(() => {
    return distributions.map((metric) => metric.name);
  }, [distributions]);

  const series = useMemo(() => {
    return distributions.map((metric) => metric.price);
  }, [distributions]);

  const chartOptions: any = {
    chart: {
      fontFamily: 'inherit',
      foreColor: 'inherit',
      height: '100%',
      type: 'polarArea',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    labels,
    legend: {
      position: 'bottom',
    },
    plotOptions: {
      polarArea: {
        spokes: {
          connectorColors: theme.palette.divider,
        },
        rings: {
          strokeColor: theme.palette.divider,
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.75,
        },
      },
    },
    stroke: {
      width: 2,
    },
    theme: {
      monochrome: {
        enabled: true,
        color: theme.palette.info.main,
        shadeIntensity: 0.75,
        shadeTo: 'light',
      },
    },
    tooltip: {
      followCursor: true,
      theme: 'light',
    },
    yaxis: {
      show: window.innerWidth >= 600,
      labels: {
        style: {
          colors: theme.palette.text.secondary,
          fontSize: window.innerWidth < 768 ? '8px' : '11px',
        },
        formatter: function (value: number) {
          if (value >= 1000000000) return '$' + (value / 1000000000).toFixed(1) + 'B';
          if (value >= 1000000) return '$' + (value / 1000000).toFixed(0) + 'M';
          if (value >= 1000) return '$' + (value / 1000).toFixed(0) + 'K';
          return '$' + value;
        },
      },
      tickAmount: window.innerWidth < 768 ? 3 : undefined,
    },
  };

  return (
    <Paper className="flex flex-col flex-auto shadow rounded-2xl overflow-hidden p-24">
      <Typography className="font-bold" color="text.secondary">
        Distribución de alertas en $
      </Typography>
      <div className="flex flex-col flex-auto" style={{ minHeight: 0, overflow: 'hidden' }}>
        <ReactApexChart
          className="flex-auto w-full"
          options={chartOptions}
          series={series}
          type={chartOptions.chart.type}
          height={window.innerWidth < 768 ? 220 : 340}
        />
      </div>
    </Paper>
  );
}

export default TotalWidget;
